import React from 'react';
import MenuButtonFilter from '@app/component/menu/MenuButtonFilter';
import ReviewsFilterInput from '@app/model/review/input/ReviewsFilterInput';

type ReviewsPeriodButtonFilterProps = {
	filter: ReviewsFilterInput;
	onFilter: (filter: ReviewsFilterInput) => void;
};

const ReviewsPeriodButtonFilter = React.memo(
	function ReviewsPeriodButtonFilter({ filter, onFilter }: ReviewsPeriodButtonFilterProps) {

		const menuItems = [
			{
				name: 'Last 3 months',
				value: 3,
			},
			{
				name: 'Last 6 months',
				value: 6,
			},
			{
				name: 'Last 1 year',
				value: 12,
			},
		];

		const onSelect = (value: number) => {
			onFilter({
				...filter,
				months: value,
			});
		};

		return <MenuButtonFilter menuItems={menuItems} selectedValue={filter.months} onSelect={onSelect} />;
	},
);

export default ReviewsPeriodButtonFilter;